import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroAirwallexBatchPaymentForm', {
    headerText: 'Airwallex Batch Payment',
    batchPaymentBillsQty: 'Airwallex Batch Payment bills: {qty}',
    addBills: 'Add Bills',
    removeAllBills: 'Remove all Bills',
    checkBeneficiaries: 'Check beneficiaries',
    bankDetailsChanged: 'Bank details have changed',
    addBillsAttentionText: '200 bills are displayed at one time.',
    confirmationPopupTitle: 'Unsaved changes',
    confirmationPopupDescription:
        'There are unsaved changes on the page. Would you like to discard them or continue editing?',
    cancelButtonText: 'Continue Editing',
    cancelButtonTitle: 'Stay on this page and continue editing',
    confirmButtonText: 'Discard Changes',
    confirmButtonTitle: 'Discard unsaved changes',
});
